(function (){
    'use strict';

    angular
        .module('services')
        .service('SendSurveyService', SendSurveyService);

    //$httpParamSerializer

    SendSurveyService.$inject = ['$http', 'API_BASE'];

    function SendSurveyService ($http, API_BASE) {
        var service = this;
        service.getVirtualFairs            = getVirtualFairs;
        service.getPhysicalFairs           = getPhysicalFairs;
        service.sendSurvey                 = sendSurvey;
        service.sendSurveyPhysicalFair     = sendSurveyPhysicalFair;

        function getVirtualFairs (currentPage) {
            return $http.get(API_BASE + '/email/send-survey/virtual-fairs?page='+currentPage);
        }
        function sendSurvey (query) {
            return $http.post(API_BASE + '/email/send-survey', query);
        }
        function getPhysicalFairs (currentPage) {
            return $http.get(API_BASE + '/email/send-survey/physical-fairs?page='+currentPage);
        }
        function sendSurveyPhysicalFair (query) {
            return $http.post(API_BASE + '/email/send-survey-physical-fair', query);
        }
    }
})();